 <div [innerHtml]="value"></div>
